import React from "react";
import { connect } from "formik";
import { MoneyInput } from "components/Global/FastFormikMaterial";

import LateralField from "./LateralField";
import ViewOnlyDiv from "./ViewOnlyDiv";

const SideLabelCalculatedField = ({ label, calculationFunc, formik, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  return (
    <LateralField label={label}>
      <ViewOnlyDiv>{calculationFunc(formik.values)}</ViewOnlyDiv>
    </LateralField>
  );
};
export default connect(SideLabelCalculatedField);
